export enum ConfidenceLevel {
  VeryConfident = "Very confident",
  Confident = "Confident",
  Unsure = "Unsure",
  NotConfident = "Not confident",
}
